'use client'

import { Suspense } from 'react'
import { VideoCallPageContent } from '@/components/video-call/VideoCallPageContent'

export default function VideoCallPage() {
  return (
    <Suspense fallback={<div className="flex h-screen items-center justify-center">Loading...</div>}>
      <VideoCallPageContent />
    </Suspense>
  )
}
